// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    env: 'dev',
    production: false,
    gaTrackingId: 'G-TDNC1KZ02L',
    authUrl: 'http://3.109.29.239:7999/api/auth',
    serverUrl: 'http://3.109.29.239:7000',
    useAuthStub: false,
    origin: 'mobile-app',
    clientIdAndSecret: 'freight-web:secret',
    securityServerUrl: 'http://3.109.29.239:7999/api/auth',
    portalAdminRoleId: 7,
    ffAdminRoleId: 8,
    customerAdminRoleId: 11,
    dummyBearer: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiKiJdLCJ1c2VyX25hbWUiOiJhdGlrQG1zbGMuaW4iLCJzY29wZSI6WyJmb28iLCJyZWFkIiwid3JpdGUiXSwibGFzdF9uYW1lIjoiIFogU0hBSUtIIiwidXNlcklkIjo0MjksImZpcnN0X25hbWUiOiJBVElLIEFIRU1FRCIsImF1dGhvcml0aWVzIjpbIlBvcnRhbCBBZG1pbiIsIlVzZXIiXSwianRpIjoiOGFmZTJiNTEtMWFmMi00MTIyLWE0ZjAtMWY5ZDBlMjMyMDI1IiwiY2xpZW50X2lkIjoiZnJlaWdodC13ZWIifQ.bxVtUw3CNFy5qboNiwWfwy_R-ieehOhsr9py7gSiAFH43GdPZ97yyZIPXRe9tj1IOLswOz9ujYfY0mtDiuIXW2QpYT7JPqZhjhRPYD7Hv4RFbrbQAUivnRq94Ofpsd0bl7met7xI5LK0V-wLvjz9LJdEjT9-JOMbfsi9ZihkMGm7AU-G_MGhca15kB4rwoDeoItFlJtUTJhF2eE7mhv0PnRZxGff_mg1uZ4eNxQb6GAHL6GRh_DASqv-auUXq8qU-nRP5hZUiI3_oEBlJFJ59SRHwfwiEx3Ic783fRKdM6MTZNCdBkt8TOG2eD36G4ibI_8Nm-IiqaKrqQGMQF2ZvQ',
};
